import { render } from "./ReportSandbox.vue?vue&type=template&id=718a1460"
import script from "./ReportSandbox.vue?vue&type=script&lang=js"
export * from "./ReportSandbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__